import { DashboardDto } from 'src/dto/dashboard.dto'
import { DashboardService } from 'src/services/api/dashboard.service'

export class DashboardController {
  private service: DashboardService

  constructor() {
    this.service = new DashboardService()
  }

  public async getDashboardInfo(farmId: string): Promise<DashboardDto[]> {
    const response = await this.service.getDashboardInfo(farmId)
    return response.data
  }
}
